var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95279 2.05554L4.51131 3.53666C3.94717 3.72478 3.64228 4.33481 3.83033 4.8992L4.23677 6.11904L10.7014 3.81026L10.3064 2.71259C10.1083 2.16224 9.50746 1.87058 8.95279 2.05554Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2093 5.22166L4.71104 7.54245L6.52372 12.9828C6.64192 13.3375 6.52885 13.7284 6.23956 13.9652L3.13548 16.506C1.8353 17.5702 1.62083 19.4777 2.6522 20.8043C3.70723 22.1613 5.66518 22.3989 7.01396 21.3337L11.1533 18.0644C8.74942 15.4284 9.67589 11.2313 12.8578 9.80281L11.2093 5.22166Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7451 12.2688C14.3633 13.9867 13.8315 15.9046 12.4251 17.059C10.7022 15.2779 11.2746 12.3816 13.4074 11.3302L13.7451 12.2688Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3344 18.2531L13.3468 18.2433L13.3768 18.2183C15.2732 16.6619 15.9899 14.0765 15.1566 11.7608L13.533 7.24892L19.2093 5.22167L20.8579 9.80281C17.676 11.2313 16.7495 15.4284 19.1534 18.0644L15.014 21.3337C13.6653 22.3989 11.7073 22.1613 10.6523 20.8043C10.5818 20.7136 10.5172 20.6203 10.4583 20.5247L12.2908 19.0774L12.3082 19.0954L13.3344 18.2531Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7013 3.81027L13.025 5.83752L12.2446 3.66867C12.325 3.61379 12.4143 3.56899 12.5113 3.53666L16.9528 2.05554C17.5074 1.87058 18.1083 2.16224 18.3063 2.71259L18.7013 3.81027Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4251 17.059C21.8315 15.9046 22.3633 13.9867 21.7451 12.2688L21.4074 11.3302C19.2746 12.3816 18.7022 15.2779 20.4251 17.059Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSock);
export default __webpack_public_path__ + "static/media/sock.64d5fc12795e1f8ef47b351ba2bd4fba.svg";
export { ForwardRef as ReactComponent };